import {css} from 'lit';
export const styles = css`.bu-btn {
  --btn-height: 36px;
  --btn-padding-x: 16px;
  --btn-padding-y: 0;
  --btn-font-size: var(--bu-font-size-sm);
  --btn-font-weight: 700;
  --btn-color: var(--dark-text);
  --btn-bg: transparent;
  --btn-border-width: 1px;
  --btn-border-color: transparent;
  --btn-border-radius: 100px;
  --btn-hover-border-color: transparent;
  --btn-disabled-opacity: 0.65;

  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: var(--btn-height);
  min-width: var(--btn-height);
  padding: var(--btn-padding-y) var(--btn-padding-x);
  font-size: var(--btn-font-size);
  font-weight: var(--btn-font-weight);
  color: var(--btn-color);
  text-decoration: none;
  font-style: normal;
  cursor: pointer;
  -webkit-user-select: none;
     -moz-user-select: none;
          user-select: none;
  border: var(--btn-border-width) solid var(--btn-border-color);
  border-radius: var(--btn-border-radius);
  background-color: var(--btn-bg);
  white-space: nowrap;
  vertical-align: top;
}

  .bu-btn[\\:has\\(bu-icon\\:only-child\\)],
  .bu-btn[\\:has\\(ef-icon\\:only-child\\)] {
    padding: 0;
    font-weight: normal;
  }

  .bu-btn:has(bu-icon:only-child),
  .bu-btn:has(ef-icon:only-child) {
    padding: 0;
    font-weight: normal;
  }

  .bu-btn[class*='btn-naked'][\\:has\\(ef-icon\\:only-child\\)] bu-icon,
  .bu-btn[class*='btn-naked'][\\:has\\(ef-icon\\:only-child\\)] ef-icon {
    font-size: 1.2em;
  }

  .bu-btn[class*='btn-naked']:has(ef-icon:only-child) bu-icon,
  .bu-btn[class*='btn-naked']:has(ef-icon:only-child) ef-icon {
    font-size: 1.2em;
  }

  .bu-btn.active {
    --icon-color-primary: var(--secondary-500);
  }

.bu-btn > bu-icon,
.bu-btn > ef-icon {
  color: var(--btn-color);
  color: var(--btn-icon-color, var(--btn-color));
  font-size: 1.36em;
  font-size: var(--btn-icon-font-size, 1.36em);
}

.bu-btn > bu-icon + span,
.bu-btn > ef-icon + span,
.bu-btn > span + bu-icon,
.bu-btn > span + ef-icon {
  margin-left: 8px;
}

.btn-primary {
  --btn-color: var(--primary-000);
  --btn-bg: var(--primary-500);
  --btn-border-color: var(--primary-500);
  --btn-hover-color: var(--primary-000);
  --btn-hover-bg: var(--primary-600);
  --btn-hover-border-color: var(--primary-600);
  --btn-active-color: var(--primary-000);
  --btn-active-bg: var(--primary-400);
  --btn-active-border-color: var(--primary-400);
  --btn-disabled-color: var(--dark-text);
  --btn-disabled-bg: var(--gray-300);
  --btn-disabled-border-color: var(--gray-300);
}

.btn-secondary {
  --btn-color: var(--secondary-000);
  --btn-bg: var(--secondary-500);
  --btn-border-color: var(--secondary-500);
  --btn-hover-color: var(--secondary-000);
  --btn-hover-bg: var(--secondary-600);
  --btn-hover-border-color: var(--secondary-600);
  --btn-active-color: var(--secondary-000);
  --btn-active-bg: var(--secondary-400);
  --btn-active-border-color: var(--secondary-400);
  --btn-disabled-color: var(--dark-text);
  --btn-disabled-bg: var(--gray-300);
  --btn-disabled-border-color: var(--gray-300);
}

.btn-success {
  --btn-color: var(--success-000);
  --btn-bg: var(--success-500);
  --btn-border-color: var(--success-500);
  --btn-hover-color: var(--success-000);
  --btn-hover-bg: var(--success-600);
  --btn-hover-border-color: var(--success-600);
  --btn-active-color: var(--success-000);
  --btn-active-bg: var(--success-400);
  --btn-active-border-color: var(--success-400);
  --btn-disabled-color: var(--dark-text);
  --btn-disabled-bg: var(--gray-300);
  --btn-disabled-border-color: var(--gray-300);
}

.btn-info {
  --btn-color: var(--info-000);
  --btn-bg: var(--info-500);
  --btn-border-color: var(--info-500);
  --btn-hover-color: var(--info-000);
  --btn-hover-bg: var(--info-600);
  --btn-hover-border-color: var(--info-600);
  --btn-active-color: var(--info-000);
  --btn-active-bg: var(--info-400);
  --btn-active-border-color: var(--info-400);
  --btn-disabled-color: var(--dark-text);
  --btn-disabled-bg: var(--gray-300);
  --btn-disabled-border-color: var(--gray-300);
}

.btn-warning {
  --btn-color: var(--warning-000);
  --btn-bg: var(--warning-500);
  --btn-border-color: var(--warning-500);
  --btn-hover-color: var(--warning-000);
  --btn-hover-bg: var(--warning-600);
  --btn-hover-border-color: var(--warning-600);
  --btn-active-color: var(--warning-000);
  --btn-active-bg: var(--warning-400);
  --btn-active-border-color: var(--warning-400);
  --btn-disabled-color: var(--dark-text);
  --btn-disabled-bg: var(--gray-300);
  --btn-disabled-border-color: var(--gray-300);
}

.btn-danger {
  --btn-color: var(--danger-000);
  --btn-bg: var(--danger-500);
  --btn-border-color: var(--danger-500);
  --btn-hover-color: var(--danger-000);
  --btn-hover-bg: var(--danger-600);
  --btn-hover-border-color: var(--danger-600);
  --btn-active-color: var(--danger-000);
  --btn-active-bg: var(--danger-400);
  --btn-active-border-color: var(--danger-400);
  --btn-disabled-color: var(--dark-text);
  --btn-disabled-bg: var(--gray-300);
  --btn-disabled-border-color: var(--gray-300);
}

.btn-naked-primary {
  --btn-color: var(--primary-text);
  --btn-bg: transparent;
  --btn-border-color: transparent;
  --btn-hover-color: var(--primary-text);
  --btn-hover-bg: var(--primary-100);
  --btn-hover-border-color: transparent;
  --btn-active-color: var(--primary-text);
  --btn-active-bg: var(--primary-200);
  --btn-active-border-color: transparent;
  --btn-disabled-color: var(--dark-text);
  --btn-disabled-bg: transparent;
  --btn-disabled-border-color: transparent;
}

.btn-naked-secondary {
  --btn-color: var(--secondary-text);
  --btn-bg: transparent;
  --btn-border-color: transparent;
  --btn-hover-color: var(--secondary-text);
  --btn-hover-bg: var(--secondary-100);
  --btn-hover-border-color: transparent;
  --btn-active-color: var(--secondary-text);
  --btn-active-bg: var(--secondary-200);
  --btn-active-border-color: transparent;
  --btn-disabled-color: var(--dark-text);
  --btn-disabled-bg: transparent;
  --btn-disabled-border-color: transparent;
}

.btn-naked-info {
  --btn-color: var(--info-text);
  --btn-bg: transparent;
  --btn-border-color: transparent;
  --btn-hover-color: var(--info-text);
  --btn-hover-bg: var(--info-100);
  --btn-hover-border-color: transparent;
  --btn-active-color: var(--info-text);
  --btn-active-bg: var(--info-200);
  --btn-active-border-color: transparent;
  --btn-disabled-color: var(--dark-text);
  --btn-disabled-bg: transparent;
  --btn-disabled-border-color: transparent;
}

.btn-naked-success {
  --btn-color: var(--success-text);
  --btn-bg: transparent;
  --btn-border-color: transparent;
  --btn-hover-color: var(--success-text);
  --btn-hover-bg: var(--success-100);
  --btn-hover-border-color: transparent;
  --btn-active-color: var(--success-text);
  --btn-active-bg: var(--success-200);
  --btn-active-border-color: transparent;
  --btn-disabled-color: var(--dark-text);
  --btn-disabled-bg: transparent;
  --btn-disabled-border-color: transparent;
}

.btn-naked-warning {
  --btn-color: var(--warning-text);
  --btn-bg: transparent;
  --btn-border-color: transparent;
  --btn-hover-color: var(--warning-text);
  --btn-hover-bg: var(--warning-100);
  --btn-hover-border-color: transparent;
  --btn-active-color: var(--warning-text);
  --btn-active-bg: var(--warning-200);
  --btn-active-border-color: transparent;
  --btn-disabled-color: var(--dark-text);
  --btn-disabled-bg: transparent;
  --btn-disabled-border-color: transparent;
}

.btn-naked-danger {
  --btn-color: var(--danger-text);
  --btn-bg: transparent;
  --btn-border-color: transparent;
  --btn-hover-color: var(--danger-text);
  --btn-hover-bg: var(--danger-100);
  --btn-hover-border-color: transparent;
  --btn-active-color: var(--danger-text);
  --btn-active-bg: var(--danger-200);
  --btn-active-border-color: transparent;
  --btn-disabled-color: var(--dark-text);
  --btn-disabled-bg: transparent;
  --btn-disabled-border-color: transparent;
}

.btn-naked-dark {
  --btn-color: var(--dark-text);
  --btn-bg: transparent;
  --btn-border-color: transparent;
  --btn-hover-color: var(--dark-text);
  --btn-hover-bg: var(--gray-300);
  --btn-hover-border-color: transparent;
  --btn-active-color: var(--dark-text);
  --btn-active-bg: var(--gray-400);
  --btn-active-border-color: transparent;
  --btn-disabled-color: var(--dark-text);
  --btn-disabled-bg: transparent;
  --btn-disabled-border-color: transparent;

  padding-left: 0.5rem;

  padding-right: 0.5rem;
}

.btn-naked-white {
  --btn-color: var(--contrast-light);
  --btn-bg: transparent;
  --btn-border-color: transparent;
  --btn-hover-color: var(--contrast-light);
  --btn-hover-bg: var(--gray-600);
  --btn-hover-border-color: transparent;
  --btn-active-color: var(--contrast-light);
  --btn-active-bg: var(--gray-700);
  --btn-active-border-color: transparent;
  --btn-disabled-color: var(--dark-text);
  --btn-disabled-bg: var(--btn-bg);
  --btn-disabled-border-color: transparent;
}

.btn-outline-primary {
  --btn-color: var(--primary-text);
  --btn-border-color: var(--primary-500);
  --btn-hover-color: var(--primary-text);
  --btn-hover-bg: var(--primary-100);
  --btn-hover-border-color: var(--primary-500);
  --btn-active-color: var(--primary-text);
  --btn-active-bg: var(--primary-200);
  --btn-active-border-color: var(--primary-500);
  --btn-disabled-color: var(--dark-text);
  --btn-disabled-bg: var(--btn-bg);
  --btn-disabled-border-color: var(--gray-700);
}

.btn-outline-secondary {
  --btn-color: var(--secondary-text);
  --btn-border-color: var(--secondary-500);
  --btn-hover-color: var(--secondary-text);
  --btn-hover-bg: var(--secondary-100);
  --btn-hover-border-color: var(--secondary-500);
  --btn-active-color: var(--secondary-text);
  --btn-active-bg: var(--secondary-200);
  --btn-active-border-color: var(--secondary-500);
  --btn-disabled-color: var(--dark-text);
  --btn-disabled-bg: var(--btn-bg);
  --btn-disabled-border-color: var(--gray-700);
}

.btn-outline-info {
  --btn-color: var(--info-text);
  --btn-border-color: var(--info-500);
  --btn-hover-color: var(--info-text);
  --btn-hover-bg: var(--info-100);
  --btn-hover-border-color: var(--info-500);
  --btn-active-color: var(--info-text);
  --btn-active-bg: var(--info-200);
  --btn-active-border-color: var(--info-500);
  --btn-disabled-color: var(--dark-text);
  --btn-disabled-bg: var(--btn-bg);
  --btn-disabled-border-color: var(--gray-700);
}

.btn-outline-success {
  --btn-color: var(--success-text);
  --btn-border-color: var(--success-500);
  --btn-hover-color: var(--success-text);
  --btn-hover-bg: var(--success-100);
  --btn-hover-border-color: var(--success-500);
  --btn-active-color: var(--success-text);
  --btn-active-bg: var(--success-200);
  --btn-active-border-color: var(--success-500);
  --btn-disabled-color: var(--dark-text);
  --btn-disabled-bg: var(--btn-bg);
  --btn-disabled-border-color: var(--gray-700);
}

.btn-outline-warning {
  --btn-color: var(--warning-text);
  --btn-border-color: var(--warning-500);
  --btn-hover-color: var(--warning-text);
  --btn-hover-bg: var(--warning-100);
  --btn-hover-border-color: var(--warning-500);
  --btn-active-color: var(--warning-text);
  --btn-active-bg: var(--warning-200);
  --btn-active-border-color: var(--warning-500);
  --btn-disabled-color: var(--dark-text);
  --btn-disabled-bg: var(--btn-bg);
  --btn-disabled-border-color: var(--gray-700);
}

.btn-outline-danger {
  --btn-color: var(--danger-text);
  --btn-border-color: var(--danger-500);
  --btn-hover-color: var(--danger-text);
  --btn-hover-bg: var(--danger-100);
  --btn-hover-border-color: var(--danger-500);
  --btn-active-color: var(--danger-text);
  --btn-active-bg: var(--danger-200);
  --btn-active-border-color: var(--danger-500);
  --btn-disabled-color: var(--dark-text);
  --btn-disabled-bg: var(--btn-bg);
  --btn-disabled-border-color: var(--gray-700);
}

.btn-outline-dark {
  --btn-color: var(--dark-text);
  --btn-border-color: var(--gray-700);
  --btn-hover-color: var(--dark-text);
  --btn-hover-bg: var(--gray-200);
  --btn-hover-border-color: var(--gray-700);
  --btn-active-color: var(--dark-text);
  --btn-active-bg: var(--gray-300);
  --btn-active-border-color: var(--gray-700);
  --btn-disabled-color: var(--dark-text);
  --btn-disabled-bg: var(--btn-bg);
  --btn-disabled-border-color: var(--gray-700);
}

.btn-thin {
  --btn-font-weight: 400;
}

/* Sizes */

.bu-btn-xs {
  --btn-height: 32px;
  --btn-font-size: var(--bu-font-size-xs);
  --btn-icon-font-size: 18px;
}

/* Sizes */

.bu-btn-sm {
  --btn-height: 32px;
  --btn-font-size: var(--bu-font-size-sm);
}

.bu-btn-md {
  --btn-height: 48px;
  --btn-font-size: var(--bu-font-size-base);
}

.bu-btn-lg {
  --btn-height: 60px;
  --btn-font-size: var(--bu-font-size-base);
}

/* States */

@media (hover: hover) {
  .bu-btn:hover {
    color: var(--btn-hover-color);
    background-color: var(--btn-hover-bg);
    border-color: var(--btn-hover-border-color);
  }
}

.bu-btn:active {
  color: var(--btn-active-color);
  background-color: var(--btn-active-bg);
  border-color: var(--btn-active-border-color);
}

.bu-btn.disabled,
.bu-btn:disabled,
fieldset:disabled .bu-btn {
  color: var(--btn-disabled-color);
  background-color: var(--btn-disabled-bg);
  border-color: var(--btn-disabled-border-color);
  opacity: var(--btn-disabled-opacity);
  cursor: not-allowed;
}

@media (max-width: 575px) {

.bu-btn-block-xs {
    display: block;
    width: 100%
}
  }

@media (min-width: 576px) and (max-width: 767px) {

.bu-btn-block-sm {
    display: block;
    width: 100%
}
  }

@media (min-width: 768px) and (max-width: 991px) {

.bu-btn-block-md {
    display: block;
    width: 100%
}
  }

@media (min-width: 992px) and (max-width: 1199px) {

.bu-btn-block-lg {
    display: block;
    width: 100%
}
  }

@media (min-width: 1200px) and (max-width: 1399px) {

.bu-btn-block-xl {
    display: block;
    width: 100%
}
  }

.bu-btn-block {
  display: block;
  width: 100%;
}

bu-card-like[active] {
  --btn-icon-color: var(--secondary-500);
}

@media (max-width: 767px) {
    .btn-comments span {
      display: none;
    }
  }

.btn-v1 {
  --background: transparent;
  --background-hover: transparent;
  --background-active: transparent;
  --border-color: transparent;

  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 10px 12px;
  border: 1px solid var(--border-color);
  border-radius: 4px;
  background-color: var(--background);
  color: var(--text-primary);
  font-size: 14px;
  font-size: var(--font-size-base, 14px);
  line-height: 1.4;
  white-space: nowrap;
  touch-action: manipulation;
  cursor: pointer;
  -webkit-user-select: none;
     -moz-user-select: none;
          user-select: none;
}

.btn-v1 ef-icon {
    margin-right: 0.3em;
    font-size: 1.33em;
    font-size: var(--icon-size-primary, 1.33em);
  }

@media (max-width: 399px) {

.btn-v1 {
    --font-size-base: 12px;

    padding: 8px
}
  }

@media (min-width: 400px) {

.btn-v1 {
    display: inline-flex;
    width: auto
}
  }

@media (hover: hover) {
    .btn-v1:hover {
      color: var(--text-primary);
      color: var(--text-primary-hover, var(--text-primary));
      background-color: var(--background-hover);
      filter: contrast(1.4);
    }
  }

.btn-v1:active {
    color: var(--text-primary);
    color: var(--text-primary-active, var(--text-primary));
    background-color: var(--background-active);
    filter: contrast(1);
  }

.btn-v1.t1 {
    --text-primary: var(--contrast-light);
    --background: var(--primary);
    --background-hover: var(--primary);
    --background-active: var(--primary);
  }

.btn-v1.t2 {
    --text-primary: var(--contrast-light);
    --background: var(--secondary);
    --background-hover: var(--secondary);
    --background-active: var(--secondary);
  }

.btn-v1.t3 {
    --text-primary: var(--contrast-light);
    --background: var(--success);
    --background-hover: var(--success);
    --background-active: var(--success);
  }

.btn-v1.t4 {
    --text-primary: var(--contrast-light);
    --background: var(--danger);
    --background-hover: var(--danger);
    --background-active: var(--danger);
  }

.btn-v1.t5 {
    --text-primary: var(--contrast-light);
    --background: var(--warning);
    --background-hover: var(--warning);
    --background-active: var(--warning);
  }

.btn-v1.t6 {
    --text-primary: var(--contrast-light);
    --background: var(--info);
    --background-hover: var(--info);
    --background-active: var(--info);
  }

.btn-v1.t7 {
    --background: var(--gray-200);
    --background-hover: var(--gray-200);
    --background-active: var(--gray-200);
    --border-color: var(--gray-400);
  }

@media (hover: hover) {
      .btn-v1.t7:hover {
        filter: contrast(0.7);
      }
    }

.btn-v1.t7:active {
      filter: contrast(0.5);
    }

.btn-v1.btn-outline {
    --background: transparent;
    --text-primary-hover: var(--contrast-light);
    --text-primary-active: var(--contrast-light);
  }

.btn-v1.btn-outline.t1 {
      --text-primary: var(--primary);
      --border-color: var(--primary);
    }

.btn-v1.btn-outline.t2 {
      --text-primary: var(--secondary);
      --border-color: var(--secondary);
    }

.btn-v1.btn-outline.t3 {
      --text-primary: var(--success);
      --border-color: var(--success);
    }

.btn-v1.btn-outline.t4 {
      --text-primary: var(--danger);
      --border-color: var(--danger);
    }

.btn-v1.btn-outline.t5 {
      --text-primary: var(--warning);
      --border-color: var(--warning);
    }

.btn-v1.btn-outline.t6 {
      --text-primary: var(--info);
      --border-color: var(--info);
    }

.btn-v1.btn-outline.t7 {
      --text-primary: var(--gray-900);
      --border-color: var(--gray-500);
      --text-primary-hover: var(--gray-900);
      --text-primary-active: var(--gray-900);
    }

.btn-v1.btn-sm {
    --font-size-base: 12px;

    padding: 4px 8px;
  }

.btn-v1.btn-round {
    border-radius: 20px;
  }

.btn-v1[disabled] {
    opacity: 0.5;
    pointer-events: none;
  }

ef-grid-list .btn-v1 {
    width: auto;
  }

.bu-title-1,
.bu-title-2,
.bu-title-3,
.bu-title-4 {
  line-height: 1.3;
}

.bu-title-1[\\:has\\(\\%3E\\%20ef-icon\\)], .bu-title-2[\\:has\\(\\%3E\\%20ef-icon\\)], .bu-title-3[\\:has\\(\\%3E\\%20ef-icon\\)], .bu-title-4[\\:has\\(\\%3E\\%20ef-icon\\)] {
    display: flex;
    align-items: center;
  }

.bu-title-1:has(> ef-icon), .bu-title-2:has(> ef-icon), .bu-title-3:has(> ef-icon), .bu-title-4:has(> ef-icon) {
    display: flex;
    align-items: center;
  }

.bu-title-1 > ef-icon, .bu-title-2 > ef-icon, .bu-title-3 > ef-icon, .bu-title-4 > ef-icon {
    margin-left: 8px;
    margin-right: 8px;
    font-size: inherit;
  }

.bu-title-1 > ef-icon:first-child, .bu-title-2 > ef-icon:first-child, .bu-title-3 > ef-icon:first-child, .bu-title-4 > ef-icon:first-child {
    margin-left: 0;
  }

.bu-title-1 > ef-icon:last-child, .bu-title-2 > ef-icon:last-child, .bu-title-3 > ef-icon:last-child, .bu-title-4 > ef-icon:last-child {
    margin-right: 0;
  }

.bu-title-1 {
  margin-top: 32px;
  margin-bottom: 32px;
  font-size: 24px;
}

@media (min-width: 768px) {

.bu-title-1 {
    font-size: 28px
}
  }

.bu-title-2 {
  margin-top: 32px;
  margin-bottom: 32px;
  font-size: 20px;
}

@media (min-width: 768px) {

.bu-title-2 {
    font-size: 24px
}
  }

.bu-title-3 {
  margin-top: 24px;
  margin-bottom: 24px;
  font-size: 18px;
}

@media (min-width: 768px) {

.bu-title-3 {
    font-size: 20px
}
  }

.bu-title-4 {
  margin-top: 16px;
  margin-bottom: 16px;
  font-size: 16px;
}

@media (min-width: 768px) {

.bu-title-4 {
    font-size: 18px
}
  }

.bu-title-1:first-child,
.bu-title-2:first-child,
.bu-title-3:first-child,
.bu-title-4:first-child {
  margin-top: 0;
}

.bu-title-1:last-child,
.bu-title-2:last-child,
.bu-title-3:last-child,
.bu-title-4:last-child {
  margin-bottom: 0;
}

:host(ef-dot-menu) {
  /* --text-primary: var(--dark-text); */

  display: block;
}

:host(ef-dot-menu) .trigger {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 28px;
    width: var(--dot-menu-trigger-width, 28px);
    max-width: 28px;
    max-width: var(--dot-menu-trigger-width, 28px);
    height: 28px;
    height: var(--dot-menu-trigger-height, 28px);
    padding: 0;
    background-color: var(--contrast-light);
    background-color: var(--dot-menu-trigger-bg, var(--contrast-light));
    border: 1px solid var(--text-secondary);
    border: var(--dot-menu-trigger-border, 1px solid var(--text-secondary));
    border-radius: 50%;
    border-radius: var(--dot-menu-trigger-radius, 50%);
    color: var(--text-secondary);
    color: var(--dot-menu-trigger-color, var(--text-secondary));
    font-size: 22px;
    font-size: var(--dot-menu-trigger-font-size, 22px);
    overflow: hidden;
    transition: all var(--transition-timing) var(--transition-duration);
    -webkit-user-select: none;
       -moz-user-select: none;
            user-select: none;
  }

@media (hover: hover) {
      :host(ef-dot-menu) .trigger:hover {
        background-color: var(--gray-100);
        background-color: var(--dot-menu-trigger-bg-hover, var(--gray-100));
      }
    }

:host(ef-dot-menu) .trigger:active {
      background-color: var(--gray-200);
      background-color: var(--dot-menu-trigger-bg-active, var(--gray-200));
    }

:host(ef-dot-menu) ef-dropdown > ul > li.facebook {
        --icon-color-primary: var(--facebook-brand-color);
      }

:host(ef-dot-menu) ef-dropdown > ul > li.twitter {
        --icon-color-primary: var(--twitter-brand-color);
      }

:host(ef-dot-menu) ef-dropdown > ul > li.whatsapp {
        --icon-color-primary: var(--whatsapp-brand-color);
      }

:host(ef-dot-menu) ef-dropdown > ul > li.active.bookmark ef-icon-block {
          --icon-color-primary: var(--primary);
        }

:host(ef-dot-menu) ef-dropdown > ul > li.active.pin ef-icon-block {
          --icon-color-primary: var(--color3);
        }

:host(ef-dot-menu) ef-dropdown > ul > li.active.subscribe ef-icon-block {
          --icon-color-primary: var(--color6);
        }

:host(ef-dot-menu) ef-dropdown > ul > li.active.favorite ef-icon-block {
          --icon-color-primary: var(--color1);
        }

:host(ef-dot-menu) ef-dropdown > ul > li.active.notifications ef-icon-block {
          --icon-color-primary: var(--color4);
        }

:host(ef-chat-list-item) {
  --chat-list-item-color: var(--gray-new-600);
  --chat-list-item-title-color: var(--gray-new-900);
  --chat-list-item-title-font-size: 16px;
  --chat-list-item-font-size: 14px;
}
`;
export default styles;
